<template>
  <b-modal
    id="modal_form"
    size="lg"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-container fluid class="p-a-0">
        <b-row>
          <b-col>
            <label>Código</label>
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="form.cd"
              name="cd"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('cd')"
              v-if="form.errors.has('cd')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Descrição</label>
            <b-form-input
              type="text"
              placeholder="Descrição"
              v-model="form.descr"
              name="descr"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('descr')"
              v-if="form.errors.has('descr')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo de Envio</label>
            <multiselect
              v-model="tpEnvioSelected"
              :options="this.$parent.optionsTpEnvio"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_envio')"
              v-if="form.errors.has('tp_envio')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Unidades</label>
            <multiselect
              v-model="unidade"
              :options-limit="300"
              :limit="10"
              :multiple="true"
              :options="this.$parent.optionsUnidade"
              track-by="unidade_id"
              label="label"
              id="unidade"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              v-text="form.errors.get('cliente')"
              v-if="form.errors.has('cliente')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row style="margin-bottom: 5px">
          <b-col>
            <label>Formato</label>
            <multiselect
              v-model="tpFormatoSelected"
              :options="this.$parent.optionsTpFormato"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_formato')"
              v-if="form.errors.has('tp_formato')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo de Integração</label>
            <multiselect
              v-model="tpIntegracaoSelected"
              :options="this.$parent.optionsTpIntegracao"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_integracao.value')"
              v-if="form.errors.has('tp_integracao.value')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Layout de entrada</label>
            <multiselect
              v-model="layoutEntradaSelected"
              :options="this.$parent.optionsLayout"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('layout')"
              v-if="form.errors.has('layout')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Layout de saida</label>
            <multiselect
              v-model="layoutSaidaSelected"
              :options="this.$parent.optionsLayout"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('layout')"
              v-if="form.errors.has('layout')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Status</label>
            <multiselect
              v-model="statusSelected"
              :options="this.$parent.optionsStatus"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('layout')"
              v-if="form.errors.has('layout')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Código do cliente</label>
            <b-form-input
              type="text"
              placeholder="Código"
              v-model="form.codigo_cliente"
              name="cd"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('codigo_cliente')"
              v-if="form.errors.has('codigo_cliente')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo de autenticação</label>
            <b-form-radio-group
              v-model="form.tp_auth"
              :options="this.$parent.optionsTpAuth"
              plain
              name="tp_regra_montagem"
              value-field="value"
            ></b-form-radio-group>
            <b-form-feedback
              v-text="form.errors.get('tp_regra_montagem')"
              v-if="form.errors.has('tp_regra_montagem')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo de entidade</label>
            <b-form-radio-group
              v-model="form.tp_entidade"
              :options="this.$parent.optionsTpEntidade"
              plain
              name="tp_entidade"
              value-field="value"
            ></b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_entidade')"
              v-if="form.errors.has('tp_entidade')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo de Trigger</label>
            <b-form-radio-group
              v-model="form.tp_trigger"
              :options="this.$parent.optionsTpTrigger"
              plain
              name="tp_trigger"
              value-field="value"
            ></b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_trigger')"
              v-if="form.errors.has('tp_trigger')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Tipo do fluxo</label>
            <b-form-radio-group
              v-model="form.tp_fluxo"
              :options="this.$parent.optionsTpFluxo"
              plain
              name="tp_fluxo"
              value-field="value"
            ></b-form-radio-group>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('tp_fluxo.value')"
              v-if="form.errors.has('tp_fluxo.value')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>

      <b-container fluid class="p-a-0" v-if="this.form.tp_envio == 1">
        <hr class="p-a-0 m-t m-b-0" />
        <div class="tbl-row p-a-0">
          <div class="tbl-cell tbl-cell-title">
            <h5 class="m-a-0">API</h5>
          </div>
        </div>
        <small class="text-muted d-block mb-2">
          As credenciais não são exibidas por segurança. Caso preenchidas, são
          atualizadas; caso em branco, permanecem as já cadastradas.
        </small>
        <b-row>
          <b-col>
            <label>Usuario API</label>
            <span
              class="badge badge-secondary ml-1"
              v-if="credenciaisCadastradas.usuario_api"
              >•••• cadastrado</span
            >
            <b-form-input
              type="password"
              autocomplete="new-password"
              :placeholder="placeholderCredencial('usuario_api', 'Usuario')"
              v-model="form.usuario_api"
              name="usuario_api"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('usuario_api')"
              v-if="form.errors.has('usuario_api')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Senha da API</label>
            <span
              class="badge badge-secondary ml-1"
              v-if="credenciaisCadastradas.senha_api"
              >•••• cadastrada</span
            >
            <b-form-input
              type="password"
              autocomplete="new-password"
              :placeholder="placeholderCredencial('senha_api', 'Senha')"
              v-model="form.senha_api"
              name="senha_api"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('senha_api')"
              v-if="form.errors.has('senha_api')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Dominio da API</label>
            <b-form-input
              type="text"
              placeholder="Dominio"
              v-model="form.dominio_api"
              name="dominio_api"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('dominio_api')"
              v-if="form.errors.has('dominio_api')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row>
          <div style="padding: 0 15px">
            <label>Endpoint Auth</label>
            <b-form-input
              type="text"
              placeholder="Endpoint Auth"
              v-model="form.endpoint_auth"
              name="descr"
            >
            </b-form-input>
            <b-form-feedback
              v-text="form.errors.get('endpoint_auth')"
              v-if="form.errors.has('endpoint_auth')"
            ></b-form-feedback>
          </div>

          <b-col>
            <label>Token</label>
            <span
              class="badge badge-secondary ml-1"
              v-if="credenciaisCadastradas.token"
              >•••• cadastrado</span
            >
            <b-form-input
              type="password"
              autocomplete="new-password"
              :placeholder="placeholderCredencial('token', 'Token')"
              v-model="form.token"
              name="token"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('token')"
              v-if="form.errors.has('token')"
            ></b-form-feedback>
          </b-col>

          <b-col>
            <label>Data que expira o token</label>
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Selecione"
              v-model="form.dt_expira_token"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('dt_expira_token')"
              v-if="form.errors.has('dt_expira_token')"
            ></b-form-feedback>
          </b-col>
          <b-col>
            <label>Endpoint da operação</label>
            <b-form-input
              type="text"
              placeholder="Endpoint operação"
              v-model="form.endpoint_operacao"
              name="descr"
            >
            </b-form-input>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('endpoint_operacao')"
              v-if="form.errors.has('endpoint_operacao')"
            ></b-form-feedback>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>Cabeçalho do auth</label>
            <span
              class="badge badge-secondary ml-1"
              v-if="credenciaisCadastradas.header_auth"
              >•••• cadastrado</span
            >
            <b-form-textarea
              id="header_auth"
              v-model="form.header_auth"
              autocomplete="off"
              :placeholder="placeholderCredencial('header_auth', '')"
            ></b-form-textarea>
            <b-form-feedback
              class="text-danger"
              v-text="form.errors.get('header_auth')"
              v-if="form.errors.has('header_auth')"
            ></b-form-feedback>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid class="p-a-0" v-if="this.form.tp_envio == 2">
        <hr class="p-a-0 m-t m-b-0" />
        <div class="tbl-row p-a-0">
          <div class="tbl-cell tbl-cell-title">
            <h5 class="m-a-0">E-mail</h5>
          </div>
        </div>
        <b-form-input
          type="email"
          style="max-width: 500px"
          placeholder="E-mail"
          v-model="form.email"
          name="email"
        >
        </b-form-input>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('email')"
          v-if="form.errors.has('email')"
        ></b-form-feedback>
      </b-container>
      <b-container fluid class="p-a-0" v-if="this.form.tp_envio == 3">
        <hr class="p-a-0 m-t m-b-0" />
        <div class="tbl-row p-a-0">
          <div class="tbl-cell tbl-cell-title">
            <h5 class="m-a-0">FTP</h5>
          </div>
        </div>
        <multiselect
          v-model="configFtpSelected"
          :options="this.$parent.optionsConfigFtp"
          style="max-width: 500px"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('config_ftp')"
          v-if="form.errors.has('config_ftp')"
        ></b-form-feedback>
      </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

/**
 * Campos de credencial da integração (TMS-8835).
 *
 * Espelha IntegracaoRequest::CAMPOS_CREDENCIAL no backend, limitado ao que
 * esta tela edita: `cookie` e `path_retorno_token` existem na API mas não têm
 * campo aqui. A API deixou de devolver o valor destes campos (eles estão em
 * `$hidden`), então a tela é write-only: nunca recebe nem exibe a credencial,
 * só grava quando o operador digita uma nova.
 */
const CAMPOS_CREDENCIAL = ["usuario_api", "senha_api", "token", "header_auth"];

/**
 * Máscara exibida no lugar do valor quando a credencial já está cadastrada.
 */
const MASCARA_CREDENCIAL = "••••••••";

/**
 * Estado inicial dos indicadores de credencial cadastrada.
 *
 * É uma função e não uma constante porque cada abertura do modal precisa de um
 * objeto próprio — compartilhar a mesma referência faria o cadastro herdar os
 * indicadores da última integração aberta em edição.
 *
 * @returns {object}
 */
function credenciaisVazias() {
  var estado = {};

  CAMPOS_CREDENCIAL.forEach(function(campo) {
    estado[campo] = false;
  });

  return estado;
}

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      unidade: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      tpFormatoSelected: [],
      tpEnvioSelected: [],
      tpIntegracaoSelected: [],
      statusSelected: [],
      layoutSelected: [],
      layoutEntradaSelected: [],
      layoutSaidaSelected: [],
      configFtpSelected: [],
      errors_array: [],
      credenciaisCadastradas: credenciaisVazias(),
      helpForm: new Form({
        cep_busca: "",
        statusRecord: [],
        params: []
      }),
      form: new Form({
        integracao_id: "",
        cd: "",
        descr: "",
        tp_entidade: "",
        tp_trigger: "",
        tp_formato: "",
        tp_envio: "",
        tp_fluxo: "",
        tp_integracao: "",
        tp_auth: "",
        endpoint_auth: "",
        token: "",
        dt_expira_token: "",
        endpoint_operacao: "",
        usuario_api: "",
        senha_api: "",
        dominio_api: "",
        email: "",
        lay_id_entrada: "",
        lay_id_saida: "",
        conftp_id: "",
        header_auth: "",
        codigo_cliente: "",
        status: "",
        unidade: []
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    tpFormatoSelected(obj) {
      this.form.tp_formato = obj.value;
    },
    tpEnvioSelected(obj) {
      this.form.tp_envio = obj.value;
    },
    tpIntegracaoSelected(obj) {
      this.form.tp_integracao = obj.value;
    },
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    layoutEntradaSelected(obj) {
      this.form.lay_id_entrada = obj.value;
    },
    layoutSaidaSelected(obj) {
      this.form.lay_id_saida = obj.value;
    },
    configFtpSelected(obj) {
      this.form.conftp_id = obj.value;
    }
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.integracao_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.credenciaisCadastradas = credenciaisVazias();
      this.errors_array = [];
      this.unidade = [];
      this.tpFormatoSelected = [];
      this.tpEnvioSelected = [];
      this.tpIntegracaoSelected = [];
      this.statusSelected = [];
      this.layoutSelected = [];
      (this.layoutEntradaSelected = []),
        (this.layoutSaidaSelected = []),
        (this.configFtpSelected = []);
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.marcarCredenciaisCadastradas(data);
      this.form.integracao_id = data.integracao_id;
      this.tpFormatoSelected = [];
      this.tpEnvioSelected = [];
      this.tpIntegracaoSelected = [];
      this.statusSelected = [];
      this.unidade = [];
      (this.layoutEntradaSelected = []),
        (this.layoutSaidaSelected = []),
        (this.configFtpSelected = []);
      this.errors_array = [];
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.codigo_cliente = data.codigo_cliente;
      this.tpEnvioSelected = {
        label: data.tp_envio.descr,
        value: data.tp_envio.valor
      };
      this.tpFormatoSelected = {
        label: data.tp_formato.descr,
        value: data.tp_formato.valor
      };
      this.tpIntegracaoSelected = {
        label: data.tp_integracao.descr,
        value: data.tp_integracao.valor
      };
      if (data.layout_entrada != null) {
        this.layoutEntradaSelected = {
          label: data.layout_entrada.descr,
          value: data.layout_entrada.lay_id
        };
      }
      if (data.layout_saida != null) {
        this.layoutSaidaSelected = {
          label: data.layout_saida.descr,
          value: data.layout_saida.lay_id
        };
      }
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      this.form.tp_auth = data.tp_auth.valor; // radio group
      this.form.tp_entidade = data.tp_entidade.valor;
      this.form.tp_trigger = data.tp_trigger.valor;
      this.form.tp_fluxo = data.tp_fluxo.valor;
      //API
      // `usuario_api`, `senha_api`, `token` e `header_auth` não são carregados
      // de propósito: a API não devolve mais o valor e o campo em branco
      // significa "manter a credencial cadastrada" (RN-06). `dominio_api`,
      // `endpoint_auth` e `dt_expira_token` não são segredo e continuam vindo.
      this.form.dominio_api = data.dominio_api;
      this.form.endpoint_auth = data.endpoint_auth;
      this.form.dt_expira_token = data.dt_expira_token;
      this.form.endpoint_operacao = data.endpoint_operacao;
      //Email
      this.form.email = data.email;
      //FTP
      if (data.config_ftp != null) {
        this.configFtpSelected = {
          label: data.config_ftp.descr,
          value: data.conftp_id
        };
      }

      //Unidades

      // if (data.integracao_unidade.length >= 1) {
      data.integracao_unidade.forEach(obj => {
        if (obj.status == 1) {
          this.unidade.push({
            label: obj.unidade.descr,
            value: obj.unidade.unidade_id,
            intuni_id: obj.intuni_id
          });
        }
      });
      // }

      this.$refs.modal_form.show();
    },
    onStore() {
      this.form.unidade = this.unidade;
      this.loading = true;
      this.isDisabled = true;
      this.dt_expira_token_label = this.form.dt_expira_token;
      // this.form.dt_expira_token = this.formatDateSubmit(this.form.dt_expira_token);
      this.semCredenciaisEmBranco(() => {
        this.form
          .post("/api/integracao/store")
          .then(response => {
            new ReturnApi(response, this);
          })
          .catch(errors => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach(obj => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
          });
      });
      this.form.dt_expira_token = this.dt_expira_token_label;
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.unidade = this.unidade;
      this.semCredenciaisEmBranco(() => {
        this.form
          .patch("/api/integracao/update/" + id)
          .then(response => {
            new ReturnApi(response, this);
          })
          .catch(errors => {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach(obj => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
          });
      });
    },
    /**
     * Marca quais credenciais a integração já tem, sem receber o valor.
     *
     * Os acessores `has_*` vêm do model do backend. Na ausência deles — API
     * antiga durante o rollout — o indicador fica desligado: é melhor não
     * mostrar "cadastrada" do que afirmar o que não se sabe.
     *
     * @param {object} data
     */
    marcarCredenciaisCadastradas(data) {
      var estado = credenciaisVazias();

      CAMPOS_CREDENCIAL.forEach(function(campo) {
        estado[campo] = data["has_" + campo] === true;
      });

      this.credenciaisCadastradas = estado;
    },
    /**
     * Placeholder do campo de credencial.
     *
     * @param {string} campo
     * @param {string} padrao
     *
     * @returns {string}
     */
    placeholderCredencial(campo, padrao) {
      return this.credenciaisCadastradas[campo] === true
        ? MASCARA_CREDENCIAL
        : padrao;
    },
    /**
     * Credencial digitada pelo operador — e não só espaço em branco.
     *
     * @param {*} valor
     *
     * @returns {boolean}
     */
    credencialPreenchida(valor) {
      return typeof valor === "string" && valor.trim() !== "";
    },
    /**
     * Envia o formulário sem os campos de credencial que ficaram em branco.
     *
     * `Form.data()` monta o payload percorrendo as chaves de `originalData`,
     * então tirar a chave de lá é o que faz o campo não ser enviado. Trocar o
     * valor por vazio não serviria: o que não pode acontecer é a tela mandar
     * `senha_api: ""` e apagar a credencial de produção de um provedor.
     *
     * A troca é feita só durante a chamada porque `Form.submit()` lê
     * `this.data()` de forma síncrona, antes de devolver a Promise — e o
     * `finally` aqui é de bloco, não de Promise: ele devolve `originalData`
     * ainda no mesmo tick, mesmo que o envio estoure.
     *
     * @param {Function} envia
     *
     * @returns {*}
     */
    semCredenciaisEmBranco(envia) {
      var originalData = this.form.originalData;
      var payload = {};
      var self = this;

      Object.keys(originalData).forEach(function(campo) {
        var ehCredencial = CAMPOS_CREDENCIAL.indexOf(campo) !== -1;

        if (ehCredencial && !self.credencialPreenchida(self.form[campo])) {
          return;
        }

        payload[campo] = originalData[campo];
      });

      this.form.originalData = payload;

      try {
        return envia();
      } finally {
        this.form.originalData = originalData;
      }
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/integracao/status")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
